// components/SelectedSubscriptions.js
import React from "react";

export const SelectedSubscriptions = ({
  selectedSubs,
  setSelectedSubs,
  anchors,
  planList,
  showConfirm,
  setShowConfirm,
  bulkAnchor,
  setBulkAnchor,
  bulkPlan,
  setBulkPlan,
  selectedPage,
  setSelectedPage,
}) => {
  const selectedItemsPerPage = 5;
  const selectedTotalPages = Math.ceil(selectedSubs.length / selectedItemsPerPage);
  const selectedIndexOfLast = selectedPage * selectedItemsPerPage;
  const selectedIndexOfFirst = selectedIndexOfLast - selectedItemsPerPage;
  const currentSelectedSubs = selectedSubs.slice(selectedIndexOfFirst, selectedIndexOfLast);

  const handleApplyToAll = () => {
    setSelectedSubs((prev) =>
      prev.map((item) => ({
        ...item,
        anchor: bulkAnchor || item.anchor,
        subscription: bulkPlan || item.subscription,
      }))
    );
  };

  return (
    <div className="mt-6">
      <div className="flex items-center gap-3">
        <b>Duplicate To</b>
        <div className="flex flex-wrap items-end gap-4 mb-4">
          <select
            value={bulkAnchor}
            onChange={(e) => setBulkAnchor(e.target.value)}
            className="border rounded px-3 py-1"
          >
            <option value="">Select Anchor</option>
            {anchors.map((a) => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>

          <select
            value={bulkPlan}
            onChange={(e) => setBulkPlan(e.target.value)}
            className="border rounded px-3 py-1"
          >
            <option value="">Select Plan</option>
            {planList.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>

          <button
            className="bg-green-600 text-white px-4 py-2 rounded h-fit"
            onClick={handleApplyToAll}
          >
            Apply to All
          </button>

          <button
            className="bg-blue-600 text-white px-4 py-2 rounded h-fit"
            disabled={selectedSubs.length === 0}
            onClick={() => setShowConfirm(true)}
          >
            Create Subscriptions
          </button>
        </div>
      </div>

      {/* Pagination for selected subs */}
      {selectedTotalPages > 1 && (
        <div className="mt-4 flex gap-2 items-center">
          <button
            onClick={() => setSelectedPage((prev) => Math.max(prev - 1, 1))}
            disabled={selectedPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>
          {Array.from({ length: selectedTotalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setSelectedPage(i + 1)}
              className={`px-3 py-1 border rounded ${selectedPage === i + 1 ? 'bg-blue-600 text-white' : ''}`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setSelectedPage((prev) => Math.min(prev + 1, selectedTotalPages))}
            disabled={selectedPage === selectedTotalPages}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}

      <div className="mt-4">
        <table className="min-w-full table-auto border">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="px-4 py-2 border">Anchor</th>
              <th className="px-4 py-2 border">Plan</th>
              <th className="px-4 py-2 border">Day</th>
              <th className="px-4 py-2 border">Time</th>
            </tr>
          </thead>
          <tbody>
            {currentSelectedSubs.map((sub) => (
              <tr key={sub.id} className="hover:bg-gray-100">
                <td className="px-4 py-2 border">
                  {anchors.find((a) => a.id === sub.anchor)?.name || 'N/A'}
                </td>
                <td className="px-4 py-2 border">
                  {planList.find((p) => p.id === sub.subscription)?.name || 'N/A'}
                </td>
                <td className="px-4 py-2 border">{sub.day}</td>
                <td className="px-4 py-2 border">{sub.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
